var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sub-table" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "组织", name: "first" } }),
          _c("el-tab-pane", { attrs: { label: "组织类型", name: "second" } }),
        ],
        1
      ),
      !_vm.disabled
        ? _c("vxe-toolbar", {
            scopedSlots: _vm._u(
              [
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-plus" },
                          on: { click: _vm.addTable },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.activeName === "first"
                                ? "添加组织"
                                : "添加组织类型"
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { color: "#f56c6c" },
                          attrs: { type: "text", icon: "el-icon-delete" },
                          on: { click: _vm.deleteTable },
                        },
                        [_vm._v("清空")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1568534020
            ),
          })
        : _vm._e(),
      _c(
        "vxe-table",
        { attrs: { data: _vm.tableList } },
        [
          _vm._l(_vm.columnList, function (config, index) {
            return _c(
              "vxe-table-column",
              _vm._b({ key: index }, "vxe-table-column", config, false)
            )
          }),
          !_vm.disabled
            ? _c("vxe-table-column", {
                attrs: {
                  title: "操作",
                  width: "60",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ rowIndex }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "setting-btn" },
                            [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    title: "此操作将永久删除该数据？",
                                    "confirm-button-type": "text",
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.removeRow(rowIndex)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "reference",
                                        type: "text",
                                      },
                                      slot: "reference",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete",
                                        staticStyle: { color: "#f5222d" },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  661982542
                ),
              })
            : _vm._e(),
        ],
        2
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }